var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"container",staticStyle:{"height":"450px","width":"950px"},attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }